import * as React from "react";
import Translate from '../../common/functions/translate';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle, faFacebook } from '@fortawesome/free-brands-svg-icons';
import logo01white from "../../assets/images/logos/Logo-01-white.png";

interface IProps {
}

interface IState {
}

class FooterComponent extends React.Component<IProps, IState> {


	public render() {
		return (
			<>
				<div className="web-footer">
					<div className="web-footer-container">
						<div className="web-footer-content">
							<img src="/images/EU-ProjectInfo.png" className="wrap-eu-project" />
							{/* <img src={logo01white} className="app-logo" alt="logo" /> */}
						</div>
						<div className="web-footer-content">
							<strong>Contacts</strong>
							<a href="https://www.google.bg/maps/place/ICB+-+InterConsult+Bulgaria/@42.7014805,23.2961192,17z/data=!4m2!3m1!1s0x40aa85494c52d7e9:0xff588da38c4c8384?hl=en"
								target="_blank" title="View on Google Maps">7, Indzhe Voivoda Str.<br />1309 Sofia, Bulgaria</a>
							<a href="tel:+35929201120" title="Call us today">+359 2 920 11 20</a>
							<a href="mailto:icb@icb.bg" title="Send mail">icb@icb.bg</a>
						</div>
						<div className="web-footer-content">
							<strong>Sales and Marketing</strong>
							<a href="tel:+35928129216" title="Call us today">+359 2 812 92 16</a>
							<a href="mailto:sales@icb.bg" title="Send mail">sales@icb.bg</a>
						</div>
						<div className="web-footer-content social-links">
							<strong>Follow us</strong>
							<a style={{ fontSize: 20 }} href="https://www.facebook.com/InterConsultBulgaria" target="_blank" title="Facebook">
								<FontAwesomeIcon icon={faFacebook} />
							</a>
							<a style={{ fontSize: 20 }} href="https://plus.google.com/+IcbBg/posts" target="_blank" title="Google +">
								<FontAwesomeIcon icon={faGoogle} />
							</a>
						</div>
					</div>
				</div>
				<div className="web-footer-small">
					<div className="web-footer-small-container">
						<div className="content-rights">
							© 2019 ICB - InterConsult Bulgaria All rights reserved
            </div>
						<div className="footer-menu">
							<Link to="/cookie-policy">{Translate('Cookies Policy')}</Link> | <Link to="/personal-data-policy">{Translate('Personal Data Policy')}</Link>
						</div>
					</div>
				</div>
			</>
		)
	}
}

export default FooterComponent;